import React from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import Preloader from "../../helper/Preloader";
import HeaderOne from "../../components/layout/HeaderOne";
import HeaderHome from "../../components/layout/HeaderHome";
import Home from "../../components/home/index";
import FooterOne from "../../components/layout/FooterOne";
import BottomFooter from "../../components/layout/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../../helper/ColorInit";
const HomePage = () => {

  return (

    <>

      {/* Preloader */}
      <Preloader />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#990A02" />

      {/* ColorInit */}
      <ColorInit color={false} />

      {/* HeaderOne */}
      <HeaderHome />

      {/* Home Component */}
      <Home />

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default HomePage;
